module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-17.a81f8b8a.jpg";